<form dw-form [formGroup]="forgetForm" class="forget-form">

  <div class="inputBlock">

    <!-- <dw-form-item dw-row style="position: relative;">
      <span class="fx_mail"><i class="anticon anticon-pushpin-o"></i></span>
      <dw-select formControlName="selectVerification" (ngModelChange)="switVerification()">
        <dw-option *ngFor="let item of optionList" [dwLabel]="item.label" [dwValue]="item.value"></dw-option>
      </dw-select>
    </dw-form-item> -->

    <!-- <dw-form-item dw-row *ngIf="forgetForm.get('selectVerification').value === 'email'" class="dw-f-email">
      <dw-form-label dw-col [dwSpan]="5">
            <i class="anticon anticon-mail"></i>
      </dw-form-label>
      <dw-form-control dw-col [dwSpan]="19">
        <input dw-input [placeholder]="'dw-forget-enterEmailReceive' | translate" formControlName="email">
        <ng-container *ngIf="forgetForm.get('email').dirty && forgetForm.get('email').errors">
          <dw-form-explain *ngIf="forgetForm.get('email').hasError('required')">{{ 'required' | translate }}</dw-form-explain>
          <dw-form-explain *ngIf="forgetForm.get('email').hasError('email')">{{ 'dw-forget-enterCorrectEmail' | translate }}</dw-form-explain>
          <dw-form-explain *ngIf="forgetForm.get('email').hasError('emailNotExist')">{{ 'dw-forget-emailNotExist' | translate }}</dw-form-explain>
        </ng-container>
      </dw-form-control>
    </dw-form-item> -->

    <div class="d-flex">
      <div class="fx_forget-width400">
        <dw-form-item dw-row *ngIf="forgetForm.get('selectVerification').value === 'mobilephone'" class="fx_forget-mt40">
          <dw-form-control dw-col [dwSpan]="24" [dwValidateStatus]="checkMobilephoneError()">
            <dw-input-group [dwAddOnBefore]="addOnBeforeTemplate" style="border-radius: 6px;background: #F2F2F2;">
              <ng-template #addOnBeforeTemplate style="height: 48px;">
                <dw-select formControlName="mobilephonePrefix" style="width: 70px;">
                  <dw-option dwLabel="+86" dwValue="+86"></dw-option>
                </dw-select>
              </ng-template>
              <input style="background: #F2F2F2;border-radius: 6px;height: 48px;" dw-input [placeholder]="'dw-forget-enterCellphone' | translate" formControlName="mobilephone">
            </dw-input-group>
          </dw-form-control>
        </dw-form-item>
      </div>
      <div *ngIf="forgetForm.get('mobilephone').dirty && forgetForm.get('mobilephone').errors" class="fx-fwn fx_forget-warin">
        <div *ngIf="forgetForm.get('mobilephone').hasError('required')">{{ 'required' | translate }}</div>
        <div *ngIf="forgetForm.get('mobilephone').hasError('minlength')">{{ 'dw-forget-needsDigits' | translate }}</div>
        <div *ngIf="forgetForm.get('mobilephone').hasError('maxlength')">{{ 'dw-forget-needsDigits' | translate }}</div>
        <div *ngIf="forgetForm.get('mobilephone').hasError('userMobilephoneNumeric')">{{ 'dw-forget-needAllNumbers' | translate }}</div>
        <div *ngIf="forgetForm.get('mobilephone').hasError('mobilephoneNotExist')">{{ 'dw-forget-cellphoneNotExist' | translate }}</div>
      </div>
    </div>

    <div class="d-flex">
      <div class="fx_forget-width400">
        <dw-form-item dw-row class="verification-block fx_forget-mt40" dwGutter="8">
          <dw-form-control dw-col [dwSpan]="16">
            <div class="d-flex">
              <input style="background: #F2F2F2;border-radius: 6px;height: 48px;" dw-input [placeholder]="'dw-forget-enterCode' | translate" formControlName="verificationCode">
            </div>
          </dw-form-control>
          <dw-form-control dw-col [dwSpan]="8" >
            <button  type="button" class="btn btn-outline-danger"  style="width:100%;height: 48px;border-radius: 6px;" [disabled]="checkGetCodeDisabled()" (click)="getCode()">{{ ((!iscountDown) ? ('dw-forget-getCode' | translate) : ('dw-forget-countDown'| translate: {'current': countDown})) }}</button>
          </dw-form-control>
        </dw-form-item>
      </div>
      <div *ngIf="forgetForm.get('verificationCode').dirty && forgetForm.get('verificationCode').errors" class="fx-fwn fx_forget-warin fx_forget-width16">
        <div *ngIf="forgetForm.get('verificationCode').hasError('required')">{{ 'required' | translate }}</div>
      </div>
    </div>

    <div *ngIf= "!is_authKey" class="fx_rest_wordP">
      <div class="fx_forget-width400">
        设置新密码
        <dw-form-item dw-row class="dw-f-newpassword" style="margin-top: 16px;">
          <dw-form-control dw-col [dwSpan]="24">
            <div>
              <input style="background: #F2F2F2;border-radius: 6px;height: 48px;" dw-input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="{{'dw-forget-enterNewPassword'|translate}}">
              <i style="margin-top: 8px;" class="anticon anticon-eye-o" [ngClass]="{'eye_blue':showPassword}" (click)="showPassword = !showPassword"></i>
            </div>
            <ng-container *ngIf="forgetForm.get('password').dirty && forgetForm.get('password').errors" class="fx-fwn">
              <dw-form-explain *ngIf="forgetForm.get('password').hasError('maxlength')">
                {{ 'maxlength' | translate:{
                'requiredLength':forgetForm.get('password').errors.maxlength.requiredLength,
                'actualLength':forgetForm.get('password').errors.maxlength.actualLength} }}
              </dw-form-explain>
              <dw-form-explain *ngIf="forgetForm.get('password').hasError('minlength')">
                {{ 'minlength' | translate:{
                'requiredLength':forgetForm.get('password').errors.minlength.requiredLength,
                'actualLength':forgetForm.get('password').errors.minlength.actualLength} }}
              </dw-form-explain>
            </ng-container>
          </dw-form-control>
        </dw-form-item>
      </div>

      <div class="d-flex">
        <div class="fx_forget-width400">
          <dw-form-item dw-row class="dw-f-confnewpassword fx_forget-mt40">
            <dw-form-control dw-col [dwSpan]="24">
              <div>
                <input style="background: #F2F2F2;border-radius: 6px;height: 48px;" dw-input [type]="showPassword ? 'text' : 'password' " formControlName="repassword" placeholder="{{'dw-forget-enterNewPasswordAgain'|translate}}">
                <i style="margin-top: 8px;" class="anticon anticon-eye-o" [ngClass]="{'eye_blue':showPassword}" (click)="showPassword = !showPassword"></i>
              </div>
            </dw-form-control>
          </dw-form-item>
        </div>
        <div *ngIf="forgetForm.get('repassword').dirty && forgetForm.get('repassword').errors" class="fx-fwn fx_forget-warin fx_forget-width16">
          <div *ngIf="forgetForm.get('repassword').hasError('required')">{{'required' | translate}}</div>
          <div *ngIf="forgetForm.get('repassword').hasError('userPasswordEqual')">{{'dw-forget-passwordMismatch' | translate}}</div>
        </div>
      </div>


      <div class="fx_forget-width400">
        <dw-form-item dw-row class="dw-f-loginagain">
          <dw-form-label dw-col [dwSpan]="24">
            <span style="font-weight: 100 !important;"><i class="anticon anticon-exclamation-circle-o"></i>{{'dw-forget-logInAgain' | translate}}</span>
          </dw-form-label>
        </dw-form-item>
        <dw-form-item dw-row class="customize-footer fx_forget-mt40">
          <dw-form-control dw-col [dwSpan]="24">
            <button dw-button [dwType]="'danger'" [disabled]="!forgetForm.valid" [dwLoading]="isButtLoading" (click)="emitDataOutside()" style="border-radius: 6px;background-color: rgb(220, 53, 69);color: #fff;">{{'确定' | translate}}</button>
            <!-- <button dw-button type="button"  [disabled]="!forgetForm.valid" [dwType]="'default'" (click)="cancel($event)">{{ 'dw-cancel' | translate}}</button> -->
          </dw-form-control>
        </dw-form-item>

        <div  class="fx_forget_back" (click)="cancel()">{{'返回登录' | translate}}</div>
      </div>
    </div>

  </div>
</form>
